// src/TextReader.js
import React, { useState } from 'react';
import './ReadText.css';

const ReadText = () => {
  const [fileContent, setFileContent] = useState('');
  const [titles, setTitles] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState('');
  const [displayText, setDisplayText] = useState('');

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        setFileContent(text);

        // Assuming titles are denoted by "Title: <title name>" in the text file
        const titles = text.match(/Title: .+/g) || [];
        setTitles(titles.map(t => t.replace('Title: ', '')));
      };
      reader.readAsText(file);
    }
  };

  const handleTitleChange = (event) => {
    const title = event.target.value;
    setSelectedTitle(title);
    
    // Extract the text for the selected title
    const regex = new RegExp(`Title: ${title}(.*?)Title:`, 's');
    const match = fileContent.match(regex);
    if (match) {
      setDisplayText(match[1].trim());
    } else {
      setDisplayText('Title not found or end of file.');
    }
  };

  return (
    <div className="text-reader">
      <h1>Text Reader</h1>
      <input type="file" accept=".txt" onChange={handleFileUpload} />
      {titles.length > 0 && (
        <div className="title-selector">
          <label>Select Title: </label>
          <select value={selectedTitle} onChange={handleTitleChange}>
            <option value="">--Choose a title--</option>
            {titles.map((title, index) => (
              <option key={index} value={title}>{title}</option>
            ))}
          </select>
        </div>
      )}
      {displayText && (
        <div className="display-text">
          <h2>{selectedTitle}</h2>
          <pre>{displayText}</pre>
        </div>
      )}
    </div>
  );
};

export default ReadText;
